// Sélecteur de date en français (shadcn Calendar) — remplace l'input date natif
import { format, parseISO } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DatePickerFr = ({ value, onChange, placeholder = "Choisir une date", testId }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button
        type="button" variant="outline"
        className={`w-full justify-start rounded-xl font-normal gap-2 ${value ? "" : "text-muted-foreground"}`}
        data-testid={testId}
      >
        <CalendarIcon className="h-4 w-4" />
        {value ? format(parseISO(value), "d MMMM yyyy", { locale: fr }) : placeholder}
      </Button>
    </PopoverTrigger>
    <PopoverContent className="w-auto p-0" align="start">
      <Calendar
        mode="single"
        locale={fr}
        selected={value ? parseISO(value) : undefined}
        onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")}
        initialFocus
      />
    </PopoverContent>
  </Popover>
);
